import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserSettingsRoutingModule } from './user-settings-routing.module';
import { UserSettingsComponent } from './pages/user-settings/user-settings.component';
import { InternalSharedModule } from '../shared';
import { SharedModule } from 'app/shared';
import { DxSwitchModule, DxTabPanelModule, DxSelectBoxModule } from 'devextreme-angular';
import { UserSettingsNotificationTabDisplayComponent } from './components/user-settings-notification-tab-display/user-settings-notification-tab-display.component';
import { UserSettingsNotificationChannelsComponent } from './components/user-settings-notification-channels/user-settings-notification-channels.component';
import { UserSettingsNotificationTasksComponent } from './components/user-settings-notification-tasks/user-settings-notification-tasks.component';
import { UserSettingsNotificationAccountComponent } from './components/user-settings-notification-account/user-settings-notification-account.component';
import { UserSettingsNotificationProjectsComponent } from './components/user-settings-notification-projects/user-settings-notification-projects.component';
import { StoreModule } from '@ngrx/store';
import * as fromUserSettings from './store/reducers/user-settings.reducer';
import { EffectsModule } from '@ngrx/effects';
import { UserSettingsEffects } from './store/effects/user-settings.effects';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    UserSettingsComponent,
    UserSettingsNotificationTabDisplayComponent,
    UserSettingsNotificationChannelsComponent,
    UserSettingsNotificationTasksComponent,
    UserSettingsNotificationAccountComponent,
    UserSettingsNotificationProjectsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InternalSharedModule,
    SharedModule,
    UserSettingsRoutingModule,
    DxTabPanelModule,
    DxSwitchModule,
    DxSelectBoxModule,
    StoreModule.forFeature(fromUserSettings.userSettingsFeatureKey, fromUserSettings.reducer),
    EffectsModule.forFeature([UserSettingsEffects])
  ]
})
export class UserSettingsModule { }